import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import Flag from '@mui/icons-material/Flag';

import Dialog, { useDialog } from '@ts-core/components/Dialog';
import Button from '@ts-core/components/Button';

import { useTextField } from '@ts-core/hooks/ui';

import ForumItemToolbarButton from './ForumItemToolbarButton';

const useStyles = makeStyles((theme) => ({
  texField: {
    m: theme.spacing(2),
  },
}));

const ReportForumItemButton = (props) => {
  const classes = useStyles();
  const intl = useIntl();
  const { onReportItem, className, contentType } = props;

  const messageTextField = useTextField('');
  const { value: message, onReset } = messageTextField;

  const { dialogProps, onOpenDialog, onCloseDialog } = useDialog();

  const onOpenReportDialog = useCallback(() => {
    onOpenDialog({
      title: intl.formatMessage({
        id:
          contentType === 'post'
            ? 'forum.reportPost.title'
            : 'forum.reportAnswer.title',
      }),
    });
  }, [onOpenDialog, intl, contentType]);

  const handleReportItem = useCallback(() => {
    onReportItem(message);
    onCloseDialog();
    onReset();
  }, [onReportItem, onCloseDialog, message, onReset]);

  return (
    <>
      <Dialog {...dialogProps}>
        <Box display="flex" flexDirection="column" width="100%" p={1}>
          <Box mb={3} fontSize={16}>
            <FormattedMessage
              id={
                contentType === 'post'
                  ? 'forum.reportPost.message'
                  : 'forum.reportAnswer.message'
              }
            />
          </Box>
          <TextField
            className={classes.textField}
            multiline
            rows={6}
            fullWidth
            variant="outlined"
            label={
              <FormattedMessage
                id="forum.reportItem.messageField.label"
                defaultMessage="Mensaje"
              />
            }
            {...messageTextField}
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button onClick={handleReportItem} color="primary">
              <FormattedMessage
                id="forum.button.reportItem"
                defaultMessage="Reportar"
              />
            </Button>
          </Box>
        </Box>
      </Dialog>
      <ForumItemToolbarButton
        className={className}
        Icon={Flag}
        title={
          <FormattedMessage
            id="forum.button.reportItem"
            defaultMessage="Reportar"
          />
        }
        onClick={onOpenReportDialog}
      />
    </>
  );
};

ReportForumItemButton.propTypes = {
  className: PropTypes.string,

  contentType: PropTypes.oneOf(['post', 'answer']).isRequired,

  onReportItem: PropTypes.func,
};

ReportForumItemButton.defaultProps = {
  className: undefined,
  onReportItem() {},
};

export default ReportForumItemButton;
